// `optimal` means the entry cleared every check; `target_optimal` (Runon scoring, #14304) means
// it cleared everything through runon, so it is set for feedback that is still suboptimal overall.

interface OptimalSignal {
  optimal?: boolean;
  target_optimal?: boolean|null;
  feedback_type?: string;
}

const ERROR_FEEDBACK_TYPE = 'error'

// The backend's error fallback sets `optimal: true` so a failed request does not trap the student.
// Completion and the editor lock want that; nothing celebratory should read it as a real success.
export const isErrorFeedback = (response?: OptimalSignal): boolean => response?.feedback_type === ERROR_FEEDBACK_TYPE

export const isTargetOptimal = (response?: OptimalSignal): boolean => {
  if (!response) { return false }
  // Responses recorded before the split only carry `optimal`.
  if (response.target_optimal === undefined) { return !!response.optimal }
  // The backend sends null when error feedback left it unable to tell.
  return response.target_optimal === true
}

export const isFullOptimal = (response?: OptimalSignal): boolean => !!response && !!response.optimal
